
<mat-tab-group
  [ngClass]="{hidden:showPeriodDiscretePerformace}"
  class="flex menu-underline"
  [selectedIndex]="selectDefault"
  (selectedIndexChange)="onTabChangedPeriod($event)"
  #menuPeriods
>
  <mat-tab
    *ngFor="let period of fixedPeriods"
    [label]="period.Period"
    [ngSwitch]="period.Period"
    [disabled]="period.Period === 'Switch'"
  >
    <ng-template mat-tab-label *ngSwitchCase="'Period1W'">
      <span>1W</span>
    </ng-template>
    <ng-template mat-tab-label *ngSwitchCase="'Period1M'">
      <span>1M</span>
    </ng-template>
    <ng-template mat-tab-label *ngSwitchCase="'Period3M'">
      <span>3M</span>
    </ng-template>
    <ng-template mat-tab-label *ngSwitchCase="'Period1Y'">
      <span>1Y</span>
    </ng-template>
    <ng-template mat-tab-label *ngSwitchCase="'PeriodStartDate'">
      <span>{{ 'k000058' | translate }}</span>
    </ng-template>
    <ng-template mat-tab-label *ngSwitchCase="'PeriodYTD'">
      <span>YTD</span></ng-template
    >
    <ng-template mat-tab-label *ngSwitchCase="'PeriodCustom'">
      <div (click)="openDialog(periodInitialDate, periodEndDate)">
        <fa-icon [icon]="['fal', 'calendar']"> </fa-icon>
      </div>
    </ng-template>
    <ng-template mat-tab-label *ngSwitchCase="'Switch'">
      <span>
        {{ portfolioCurrency }}&nbsp;

        <!--*ngIf="campaign.IsOwner"-->
        <span
            style="padding-left: 10px; cursor: pointer"
            matTooltip="{{ chartPercentage? ('k004383'| translate) : ('k004384' | translate) }}"
            #tooltip="matTooltip"
            (click)="tooltip.toggle()"
        >
        <mat-slide-toggle
          [checked]="chartPercentage"
          (change)="chartSwitchChange($event)"
          >%
        </mat-slide-toggle>
        </span>
      </span>
    </ng-template>
  </mat-tab>
  <!--
  <span>
    {{ portfolioCurrency }}&nbsp;
      <mat-slide-toggle
        [checked]="chartPercentage"
        (change)="chartSwitchChange($event)"
        >%
      </mat-slide-toggle>
    </span>-->
</mat-tab-group>
<mat-tab-group
[ngClass]="{hidden:!showPeriodDiscretePerformace}"
class="flex menu-underline"
[selectedIndex]="selectDefaultDiscretePerformace"
(selectedIndexChange)="onTabChangedPeriodDiscretePerformace($event)"
#menuPeriodsDiscretePerformace
>
<mat-tab
  *ngFor="let period of periodDiscretePerformace"
  [label]="period.Period"
  [ngSwitch]="period.Period"
  [disabled]="period.Period === 'Switch'"
>
  <ng-template mat-tab-label *ngSwitchCase="'Annual'">
    <span>{{ period.Name | translate }}</span>
    <!-- Token: Anual -->
  </ng-template>
  <ng-template mat-tab-label *ngSwitchCase="'Quarterly'">
    <span>{{ period.Name | translate }}</span>
    <!-- Token: Quarterly -->
  </ng-template>
  <ng-template mat-tab-label *ngSwitchCase="'Monthly'">
    <span>{{ period.Name | translate }}</span>
    <!-- Token: Monthly -->
  </ng-template>
  <ng-template mat-tab-label *ngSwitchCase="'Switch'">
    <span>
      {{ portfolioCurrency }}&nbsp;
      <span
          style="padding-left: 10px; cursor: pointer"
          matTooltip="{{ chartPercentage? ('k004383'| translate) : ('k004384' | translate) }}"
          #tooltip="matTooltip"
          (click)="tooltip.toggle()"
      >
      <mat-slide-toggle
        [checked]="chartPercentage"
        (change)="chartSwitchChange($event)"
        >%
      </mat-slide-toggle>
      </span>
    </span>
  </ng-template>
</mat-tab>
</mat-tab-group>
<div class="flex-container-row w-100 chart-switch">
  <!--
  {{ portfolioCurrency }}&nbsp;
  <mat-slide-toggle
    [checked]="chartPercentage"
    (change)="chartSwitchChange($event)"
    >%
  </mat-slide-toggle>-->
</div>
<tech-loading-peq *ngIf="loadingGraficProfilePortfolio"></tech-loading-peq>
<div 
[ngClass]="{hidden:!showPeriodDiscretePerformace}"
class="GrafDiscretePerformaceTitle">
{{ 'k004406'  | translate }} <fa-icon class="ml-1 pointer blue2" icon="info-circle" (click)="viewHintHelp($event)"></fa-icon>
<!-- token: Evolución rentabilidad de la cartera -->
</div>
<div id="graficProfilePortfolio" class="margen1" #graficProfilePortfolio></div>
